import { SYSTEM_EDITIONS } from "Components/Constants/SystemEditions";
import { CLIENTS } from "./Clients";

export const System = {
  SYSTEM_EDITION: SYSTEM_EDITIONS.BIZ_X_POS,
  CLIENT: CLIENTS.GEETHA,
};

export const company = [
  {
    Client: CLIENTS.LATHEEF_STORES,
    name: "LATHEEF STORES",
    shortName: "",
    address: "Merza Road, Sainthamaruthu-05",
    phone: "077 921 5498",
    phone2: "075 737 4313",
    email: "",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/latheef-stores",
  },
  {
    Client: CLIENTS.KATHEEJAS,
    name: "KATHEEJAS",
    shortName: "",
    address: "Merza Road, Sainthamaruthu-05",
    phone: "077 921 5498",
    phone2: "075 737 4313",
    email: "",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/katheejah",
  },
  {
    Client: CLIENTS.SPEED,
    name: "SPEED",
    shortName: "",
    address: "",
    phone: "",
    phone2: "",
    email: "",
    logo: "",
    backup: "",
  },
  {
    Client: CLIENTS.AYSHA_MOTORS,
    name: "AYSHA MOTORS",
    shortName: "",
    address: "",
    phone: "",
    phone2: "",
    email: "",
    logo: "",
    backup: "",
  },
  {
    Client: CLIENTS.POWER_POINT,
    name: "Power Point",
    shortName: "",
    address: "Merza Road, Sainthamaruthu-05",
    phone: "077 921 5498",
    phone2: "075 737 4313",
    email: "",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/power-point-new",
  },
  {
    Client: CLIENTS.ALL_FOCUS,
    name: "ALL FOCUS (PVT) LTD",
    shortName: "",
    address: "School Road, Gallella,Polonnaruwa",
    phone: "027 222 2512",
    phone2: "077 324 0392",
    email: "allfoucuspvtltd512@gmail.com",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/All-Focus",
  },
  {
    Client: CLIENTS.SUFIYAN_HARDWARE,
    name: "SUFIYAN HARDWARE",
    shortName: "",
    address: "17, Main Street Maruthamunai-03",
    phone: "077 534 6296",
    phone2: "067 222 9139",
    email: "sufiyanhardware@gmail.com",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/sufiyan-hardware",
  },
  {
    Client: CLIENTS.ISITHA_SERVICE_CENTER,
    name: "ISITHA SERVICE CENTER",
    shortName: "",
    address: "N.D. Silva & Sons Lanka Filling Station, Damana Road, Hingurana",
    phone: "063 22 40 224",
    phone2: "071 818 7703",
    email: "",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/isitha-service-center",
  },
  {
    Client: CLIENTS.ABDEEN_TYRE_HOUSE,
    name: "FAJAH RICE MILL",
    shortName: "",
    address: "Potuvil Road, Akkaraipattu",
    phone: "",
    phone2: "",
    email: "",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/abdeen-tyre-house",
  },
  {
    Client: CLIENTS.OXOGREEN_PACKAGING,
    name: "OXOGREEN PACKAGING",
    shortName: "",
    address: "",
    phone: "",
    phone2: "",
    email: "",
    logo: "",
    backup: "",
  },
  {
    Client: CLIENTS.LACE_EMPORIUM,
    name: "LACE EMPORIUM",
    shortName: "",
    address: "No. 246, 2nd Cross Street, Colombo 11. Sri Lanka",
    phone: "+94 112 348 282",
    phone2: "+94 773 114 847",
    email: "nowshy84@gmail.com",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/lace-emporium",
  },
  {
    Client: CLIENTS.PEAK_EMPIRE,
    name: "PEAK EMPIRE",
    shortName: "",
    address: "Potuvil Road Akkaraipattu",
    phone: "076 667 39 89",
    phone2: "",
    email: "",
    logo: "",
    backup: "https://titum.org.lk/titum-backup/peak-empire",
  },
  {
    Client: CLIENTS.MALI_ENTERPRISES,
    name: "MALI ENTERPRISES",
    shortName: "",
    address: "Potuvil Road Akkaraipattu",
    phone: "0766588202",
    phone2: "0777128341",
    email: "",
    logo: "",
  },
  {
    Client: CLIENTS.EAST_TOP_DISTRIBUTORS,
    name: "EAST TOP DISTRIBUTORS",
    shortName: "",
    address: "",
    phone: "0775558565",
    phone2: "0776030119",
    email: "",
    logo: "",
  },
  {
    Client: CLIENTS.WINGS,
    name: "WINGS",
    shortName: "",
    address: "",
    phone: "0771752468",
    phone2: "",
    email: "",
    logo: "",
  },
  {
    Client: CLIENTS.ORBIT,
    name: "ORBIT",
    shortName: "",
    address: "",
    phone: " ",
    phone2: "",
    email: "",
    logo: "",
  },
  {
    Client: CLIENTS.GEETHA,
    name: "GEETHA",
    shortName: "",
    address: "Paddiruppu Junction, Kaluwanchikudy, Batticaloa",
    phone: "075 888 7106",
    phone2: "075 782 2907",
    email: "",
    logo: "",
  },
  {
    Client: CLIENTS.NIHON,
    name: "NIHON",
    shortName: "",
    address: "",
    phone: " ",
    phone2: "",
    email: "",
    logo: "",
  },
].filter((item) => item.Client === System.CLIENT)[0];
